import {
    FETCH_GOLF_LEADERBOARD,
    FETCH_GOLF_LEADERBOARD_FETCHING,
    FETCH_GOLF_LEADERBOARD_SUCCESS,
    FETCH_GOLF_LEADERBOARD_FAIL
} from 'actions/golfLeaderboardActions';

const INITIAL_STATE = {
    leaderboards: {},
    leaderboardFetching: false,
    leaderboardFetchSuccess: false,
    leaderboardFetchFail: false
};

// ======= Fetching Handlers =======
const leaderboardFetching = (state) => {
    return {
        ...state,
        leaderboardFetching: true,
        leaderboardFetchSuccess: false,
        leaderboardFetchFail: false
    };
};

const leaderboardFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        leaderboards:
            success && !!action.leaderboard // Fetch can return empty
                ? {
                      ...state.leaderboards,
                      [action.leaderboard.leaderboard.id]: action.leaderboard
                  }
                : state.leaderboards,
        leaderboardFetching: false,
        leaderboardFetchSuccess: success,
        leaderboardFetchFail: !success
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_GOLF_LEADERBOARD_FETCHING]: leaderboardFetching,
    [FETCH_GOLF_LEADERBOARD_SUCCESS]: leaderboardFetchFinished(true),
    [FETCH_GOLF_LEADERBOARD_FAIL]: leaderboardFetchFinished(false)
};

// ======= Default Action =======
export default function golfLeaderboard(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======

export const isLeaderboardFetching = (state) => {
    return state.golfLeaderboard.leaderboardFetching;
};

export const didLeaderboardFetchFail = (state) => {
    return state.golfLeaderboard.leaderboardFetchFail;
};

export const getLeaderboard = (state, leaderboardId) => {
    return state.golfLeaderboard.leaderboards[leaderboardId] || {};
};

export const getLeaderboardByScorecardId = (state, scorecardId) => {
    const leaderboard = Object.entries(state.golfLeaderboard.leaderboards).find(
        (pair) => pair[1].standings.currentPlayerStanding.scorecardId === scorecardId
    );
    return leaderboard ? leaderboard[1] : {};
};

export const hasLeaderboard = (state, scorecardId) => {
    return !!getLeaderboardByScorecardId(state, scorecardId).id;
};

// ======= Actions =======

export function fetchLeaderboard(leaderboardId) {
    return {
        type: FETCH_GOLF_LEADERBOARD,
        leaderboardId: leaderboardId
    };
}

export function fetchLeaderboardByScorecard(scorecardId) {
    return {
        type: FETCH_GOLF_LEADERBOARD,
        scorecardId: scorecardId
    };
}

export function fetchLeaderboardByCourse(courseId, date) {
    return {
        type: FETCH_GOLF_LEADERBOARD,
        courseId: courseId,
        date: date
    };
}
